export const LOADING_CLASS = 'loading';
